import data from "../../../../platform_common_constants/metrics.json"

export const MetricUId = data;